import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Text } from "@merge-api/merge-javascript-shared";
import clsx from "clsx";
import { CONDUCTOR_ACCOUNT_SPEEDS_PATH, CONDUCTOR_FLAGS_PATH } from "../../../router/RouterUtils";
import ConductorFlagsPage from "../flags/ConductorFlagsPage";
import AccountSpeedsPage from "../scheduling/AccountSpeedsPage";

// Global conductor configuration. Playbooks and plans stay on the integration
// page because they are integration-scoped; everything here is not. Subtabs are
// path-based so a tab can be linked and reloaded.
const SUBTABS = [
  { label: "Flags", path: CONDUCTOR_FLAGS_PATH },
  { label: "Account speeds", path: CONDUCTOR_ACCOUNT_SPEEDS_PATH },
];

const ConductorAdminPage = () => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="px-8 pb-8 pt-24">
      <Text variant="h3">Conductor</Text>
      <Text variant="sm" className="mt-2 block text-gray-60">
        Configuration owned by the conductor service that is not scoped to one integration
      </Text>

      <div className="mt-8 flex items-start gap-8">
        <nav className="flex w-44 shrink-0 flex-col gap-1">
          {SUBTABS.map((subtab) => {
            const selected = location.pathname.startsWith(subtab.path);
            return (
              <button
                key={subtab.path}
                onClick={() => history.push(subtab.path)}
                className={clsx(
                  "rounded-md px-3 py-2 text-left text-sm",
                  selected
                    ? "bg-gray-0 font-medium text-gray-90"
                    : "text-gray-60 hover:bg-gray-0 hover:text-gray-90"
                )}
              >
                {subtab.label}
              </button>
            );
          })}
        </nav>

        <div className="min-w-0 flex-1">
          <Switch>
            <Route exact path={CONDUCTOR_FLAGS_PATH} component={ConductorFlagsPage} />
            <Route exact path={`${CONDUCTOR_FLAGS_PATH}/:flagId`} component={ConductorFlagsPage} />
            <Route exact path={CONDUCTOR_ACCOUNT_SPEEDS_PATH} component={AccountSpeedsPage} />
            <Redirect to={CONDUCTOR_FLAGS_PATH} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default ConductorAdminPage;
